import {useObservable} from '@vueuse/rxjs'
import {liveQuery} from 'dexie'
import {db} from '@src/services/db'

export function useMessages() {
    function getMessagesBySessionId(id: number) {
        return useObservable(
            // @ts-ignore
            liveQuery(async () => {
                const messages = await db.messages
                    .where('chat_session_id')
                    .equals(id)
                    .toArray()

                return messages
            }),
            {
                initialValue: []
            }
        )
    }

    function deleteMessage(messageId: number) {
        return db.messages.update(messageId, {
            status: '5'
        })
    }

    return {
        getMessagesBySessionId,
        deleteMessage
    }
}